import type { FormError } from 'components/form/error';

export class ValidationFailedError extends Error {
  constructor(
    public readonly errors: readonly FormError[],
    message = 'Validation failed',
  ) {
    super(message);
    this.name = 'ValidationFailedError';
  }
}
